import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import ProjectManagerSearchGoodsList from "./list";

const ProjectManagerSearchGoods = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const Location = useLocation();
  
  return (
    <>
      <div className="main-page-container">
        <Routes>
          <Route
            path={`/`}
            element={<Navigate replace="/" to={`${Location.pathname}/list`} />}
          ></Route>
          <Route path={"list"} element={<ProjectManagerSearchGoodsList />}></Route>
        </Routes>
      </div>
    </>
  );
};

export default ProjectManagerSearchGoods;
